module.exports = __webpack_public_path__ + "img/mobile/General/spelpaus@3x.png?1.0.17";